import {
  Flex,
  Box,
  Text,
  Alert,
  AlertIcon,
  AlertDescription,
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  VStack,
  useBreakpointValue,
} from '@wegroup/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { handleResponseLanguage } from '../../../../../i18n';
import { RiskObjectError } from '../../../../../types/Quotes';
import InsuranceCompanyLogo from '../../../../common/src/components/InsuranceCompanyLogo';

interface Props {
  riskObjectErrors: RiskObjectError[];
}

const OffersRiskObjectErrors: React.FC<React.PropsWithChildren<Props>> = ({
  riskObjectErrors,
}) => {
  const { t } = useTranslation();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const isCentered = useBreakpointValue({ base: false, laptop: true });

  return (
    <>
      <Alert status="error" mb="6" p={{ base: '3', tabletS: '6' }}>
        <AlertIcon />
        <AlertDescription
          justifyContent="space-between"
          w="100%"
          flexDirection={{ base: 'column', tablet: 'row' }}
        >
          {t('Some offers could not be retrieved for some companies')}
          <Button
            variant="dangerPrimary"
            ml={{ base: '0', tablet: '4' }}
            mt={{ base: '4', tablet: 0 }}
            onClick={onOpen}
          >
            {t('More info')}
          </Button>
        </AlertDescription>
      </Alert>
      <Modal isOpen={isOpen} onClose={onClose} isCentered={isCentered}>
        <ModalOverlay />
        <ModalContent maxW="680px" w="100%">
          <ModalHeader mr="4">
            {t('Some acceptation checks failed')}
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {t(
              'The following companies have not accepted the given information for the following reasons Therefore, no offers can be returned for these companies',
            )}
            <VStack my="4" spacing="4" align="stretch">
              {riskObjectErrors.map(({ company, detail }, index) => (
                <Flex
                  key={index}
                  border="1px"
                  borderColor="gray.ultraLight"
                  boxShadow="level2"
                  align="center"
                >
                  <Box
                    w="24"
                    h="24"
                    borderRight="1px"
                    borderColor="gray.ultraLight"
                    p="4"
                    flexShrink={0}
                  >
                    {<InsuranceCompanyLogo insuranceCompany={company} /> ||
                      company}
                  </Box>
                  <Text p="4">{handleResponseLanguage(detail)}</Text>
                </Flex>
              ))}
            </VStack>
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              {t('Close')}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default OffersRiskObjectErrors;
